module.exports = __webpack_public_path__ + "static/media/congratulations.c8833952.svg";